import type { BrebQrPayTranslations } from "../interfaces/brebQrPay";

export const brebQrPayTranslations: BrebQrPayTranslations = {
  scan_button: "Escanear QR",
  scan_not_breb: "Esse código não é um QR Bre-B.",
  scan_image_no_qr: "Não encontramos um QR na imagem.",
  scan_image_failed: "Não conseguimos ler a imagem. Tente outra.",

  camera_title: "Escaneie o QR Bre-B",
  camera_hint: "Centralize o código dentro do quadro",
  camera_close: "Fechar câmera",
  camera_starting: "Abrindo a câmera…",
  camera_foreign_qr: "Esse código não é um QR Bre-B",
  camera_torch_on: "Lanterna",
  camera_torch_off: "Desligar lanterna",
  camera_upload: "Enviar imagem",
  camera_retry: "Tentar novamente",
  camera_denied_title: "Sem permissão para usar a câmera",
  camera_denied_text:
    "Permita o acesso à câmera nas configurações do navegador e tente novamente, ou envie uma imagem do QR.",
  camera_not_found: "Não encontramos uma câmera neste dispositivo. Envie uma imagem do QR.",
  camera_in_use: "Outro aplicativo está usando a câmera. Feche-o e tente novamente.",
  camera_insecure: "A câmera só funciona em uma conexão segura (HTTPS).",
  camera_unsupported: "Este navegador não permite usar a câmera. Envie uma imagem do QR.",
  camera_error: "Não conseguimos abrir a câmera.",

  resolving: "Verificando o código…",
  resolve_invalid_title: "QR inválido",
  resolve_invalid_text: "Não conseguimos ler este código como um QR Bre-B. Escaneie de novo ou peça outro.",
  resolve_key_not_found_title: "Chave inválida",
  resolve_key_not_found_text: "A chave deste QR não existe ou está inativa. Peça um código novo.",
  resolve_unavailable_title: "Não conseguimos verificar o código",
  resolve_unavailable_text: "Verifique sua conexão e tente novamente.",
  resolve_access_denied_title: "Sem acesso",
  resolve_access_denied_text: "Seu usuário não tem permissão para consultar pagamentos.",
  resolve_unsupported_title: "QR não suportado",
  resolve_unsupported_text:
    "Por enquanto não é possível pagar este QR pela Coloca. Use outro meio de pagamento no estabelecimento.",
  resolve_retry: "Tentar novamente",
  resolve_scan_another: "Escanear outro código",
  qr_clear: "Remover QR",

  payee_label: "Você vai pagar a",
  payee_merchant: "Comércio",
  payee_person: "Pessoa",
  payee_bank: "Banco",
  payee_key: "Chave",
  payee_document: "Documento",
  payee_reference: "Referência",
  payee_inactive: "A chave não está ativa (status: {{status}}). Não é possível pagar.",

  amount_fixed_hint: "Definido pelo código e não pode ser alterado. A tarifa é somada a este valor.",

  block_amount_mismatch: "Não é possível pagar exatamente este valor. Escaneie o código novamente.",
  resolve_not_enabled_title: "Pagar com QR não está disponível",
  resolve_not_enabled_text: "Por enquanto sua organização não pode pagar QR pela Coloca.",
};
